module.exports = __webpack_public_path__ + "static/img/error-toast.d9996c62.svg";